
import request from '@/request'
const part_url = '/train/web/examination/';

/**
 * 获取考试详情
 *
 *  @param {*} examinationId 考试id
 * @returns
 */
function getExaminationDetail(data) {
    let url = part_url + "getExaminationDetail";
    return request.get(url, data)
}

/**
 * 开始考试获取题目
 * @param {*} examinationId 考试id
 * @param {*} testpaperId 试卷id
 * @param {*} type 考试模式    1 练习模式 2 考试模式
 * @returns
 */
function getStartExamination(data) {
    let url = part_url + "startExamination";
    return request.get(url, data)
}


/**
 * 记录答案
 *
 * @param {*} recordId 记录ID
 * @param {*} subjectId 题目ID
 * @param {*} answer 答案
 * @param {*} type 类型 examination 考试、practiceExam 模拟考试
 * @returns
 */
function answerProcess(data) {
    let url = part_url + "answerProcess";
    return request.get(url, data)
}

/**
 * 提交考试
 *
 * @param {*} recordId 记录ID
 * @returns
 */
function submitExamination(data) {
    let url = part_url + "submitExamination";
    return request.get(url, data)
}

function selectUserMessage(data) {
    let url = part_url + "selectUserMessage";
    return request.get(url,data)
}

//获取
function getRemainingTime(data){
    let url = part_url + "getRemainingTime";
    return request.get(url, data)
}

export default {
    getExaminationDetail,
    getStartExamination,
    answerProcess,
    submitExamination,
    selectUserMessage,
    getRemainingTime
}



// WEBPACK FOOTER //
// ./src/api/text.js